import {
    AfterContentChecked,
    ChangeDetectorRef,
    Component,
    HostBinding,
    OnDestroy,
    OnInit,
    ViewChild
} from "@angular/core";
import {GroupedOutletCustomSearchModel} from "../grouped-outlet-custom-search.model";
import {AuthService, provideSearchModel} from "@fedeltapointofsale/data-client";
import {Router} from "@angular/router";
import {
    LocalisationOutletSelectionComponent
} from "../localisation-outlet-selection/localisation-outlet-selection.component";
import {Subscription} from "rxjs";
import {LocalisationPageStackedParams} from "./localisation-page-stacked-params";
import {FUIStackedPageContextService} from "@fedeltapointofsale/ui";


@Component({
    selector: "wbo-localisation-page",
    templateUrl: "./localisation-page.component.html",
    providers: [provideSearchModel(GroupedOutletCustomSearchModel)]
})
export class LocalisationPageComponent implements OnInit, OnDestroy, AfterContentChecked {
    @ViewChild(LocalisationOutletSelectionComponent) outletSelectionPanel: LocalisationOutletSelectionComponent;

    @HostBinding("style.display") private display: string = "flex";
    @HostBinding("style.width") private width: string = "100%";

    showRestricted: boolean;

    selectedOutlets: Array<number>;
    selectedCustomObjects: Array<number>;
    universal: boolean;

    subscriptions: Subscription = new Subscription();

    constructor(public searchModel: GroupedOutletCustomSearchModel,
                private authService: AuthService,
                private router: Router,
                private changeDetectorRef: ChangeDetectorRef,
                public stackedPageContextService: FUIStackedPageContextService) {
        const request: LocalisationPageStackedParams = stackedPageContextService.params;
        this.opened(request.selectedOutlets, request.selectedCustomObjects, request.universal);

        this.showRestricted = request.showRestricted;

        this.stackedPageContextService.title = "wbo.localisation.heading.pageTitle";

        this.subscriptions.add(this.stackedPageContextService.onCloseRequest.subscribe((closeConfirmation) => closeConfirmation.canClose = true));
    }

    ngOnInit(): void {
        this.searchModel.filter["nonRestriction"] = "true";
        this.searchModel.search();
    }

    opened(selectedOutlets: Array<number>, selectedCustomObjects: Array<number>, universal: boolean = false): void {
        this.selectedOutlets = selectedOutlets ? Array.from(selectedOutlets) : [];
        this.selectedCustomObjects = selectedCustomObjects ? Array.from(selectedCustomObjects) : [];
        this.universal = universal;
    }

    cancelLocalisation(): void {
        this.stackedPageContextService.cancel();
    }

    confirmLocalisation(): void {
        this.stackedPageContextService.confirm(new LocalisationPageStackedParams(this.showRestricted, this.selectedOutlets, this.selectedCustomObjects, this.universal));
    }

    get restricted(): boolean {
        return !this.universal;
    }

    set restricted(restricted: boolean) {
        this.universal = !restricted;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngAfterContentChecked(): void {
        this.changeDetectorRef.detectChanges();
    }
}
